import React, { useEffect, useMemo, useState } from 'react';
import { Box, Breadcrumbs, Button, Fab, Link, Tooltip } from '@mui/material';
import moment from 'moment';
import { DialogDateRange, ImportDialog, MdiIcon, Table, WaitDialog } from '@components';
import { useModal } from 'mui-modal-provider';
import { mdiDownload, mdiPlus, mdiUpload } from '@mdi/js';
import DialogParceiro from './parceiro';
const OblerProcessosListView = ({ $state, UIService, OblProcessoService }) => {
    const loadParams = () => {
        const sortBy = $state.params.sortBy;
        if (sortBy == undefined) {
            return [];
        }
        const o = [];
        sortBy.forEach(r => {
            const s = r.split(':');
            o.push({ id: s[0], desc: s[1] == 'DESC' });
        });
        return o;
    };
    const { showModal } = useModal();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [estados, setEstados] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [valencias, setValencias] = useState([]);
    const [tecnicos, setTecnicos] = useState([]);
    const [refetching, setRefetching] = useState(false);
    const [options, setOptions] = useState({
        filter: [],
        sort: []
    });
    const [pagination, setPagination] = useState({
        pageIndex: $state.params.page - 1 || 0,
        pageSize: $state.params.limit || 20
    });
    const [filter, setFilter] = useState([]);
    const [sort, setSort] = useState(() => loadParams());
    const columns = useMemo(() => [
        {
            accessorKey: 'id',
            header: '#',
            size: 100,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.processos.details', { id: row.original.id }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'numeroProcesso',
            header: 'Nº Processo',
            size: 100,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.processos.details', { id: row.original.id }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'parceiro',
            header: 'Parceiro',
            size: 100
        },
        {
            accessorKey: 'valenciaId',
            exportKey: 'Valencia.designacao',
            header: 'Valência',
            filterSelectOptions: valencias.map(r => {
                return {
                    label: `${r.categoria.designacao} - ${r.designacao}`,
                    value: r.id
                };
            }),
            size: 300,
            Cell: ({ row }) => (row.original?.Valencia ? `${row.original?.Valencia?.categoria?.designacao} - ${row.original?.Valencia?.designacao}` : '')
        },
        {
            accessorKey: 'estadoId',
            exportKey: 'Estado.designacao',
            header: 'Estado',
            filterSelectOptions: estados.map(r => {
                return {
                    label: r.designacao,
                    value: r.id
                };
            }),
            size: 140,
            Cell: ({ row }) => row.original?.Estado?.designacao
        },
        {
            accessorKey: 'clienteId',
            exportKey: 'Cliente.nome',
            header: 'Cliente',
            filterSelectOptions: clientes.map(r => {
                return {
                    label: r.nome,
                    value: r.id
                };
            }),
            size: 140,
            Cell: ({ row }) => row.original?.Cliente?.nome
        },
        {
            accessorKey: 'nomeCliente',
            header: 'Proprietário',
            size: 200
        },
        {
            accessorKey: 'nifCliente',
            header: 'NIF',
            size: 150
        },
        {
            accessorKey: 'tlmCliente',
            header: 'Contacto',
            size: 150
        },
        {
            accessorKey: 'morada',
            header: 'Morada',
            size: 350
        },
        {
            accessorKey: 'cep',
            header: 'Cód. Postal',
            size: 150
        },
        {
            accessorKey: 'localidade',
            header: 'Localidade',
            size: 150
        },
        {
            accessorKey: 'data',
            header: 'Data de criação',
            size: 150,
            Cell: ({ renderedCellValue, row }) => (row.original.data && moment(row.original.data).isValid() ? moment(row.original.dataCriacao).format('DD/MM/YYYY') : 'N/D')
        }
        /*{
          accessorKey: 'ultimaAlteracao ',
          header: 'Última Alteração',
          size: 150,
          Cell: ({ renderedCellValue, row }) => (row.original.ultimaAlteracao && moment(row.original.ultimaAlteracao).isValid() ? moment(row.original.ultimaAlteracao).format('DD/MM/YYYY') : 'N/D')
        }
          */
    ], [estados, clientes, valencias]);
    const getType = (type) => {
        switch (type) {
            case 'contains':
                return '$ilike';
            case 'startsWith':
                return '$sw';
            case 'notEquals':
                return '$not';
            case 'empty':
                return '$null';
            case 'notEmpty':
                return '$notNull';
            case 'greaterThan':
                return '$gt';
            case 'greaterThanOrEqualTo':
                return '$gte';
            case 'lessThan':
                return '$lt';
            case 'lessThanOrEqualTo':
                return '$lte';
            default:
                return '$eq';
        }
    };
    const importProcessos = async () => {
        const wait = showModal(WaitDialog, { title: 'Por favor aguarde...' });
        const lotes = await OblProcessoService.getLotes();
        const tarefas = await OblProcessoService.getTipoTarefa();
        const parceiros = await OblProcessoService.getParceiros();
        wait.destroy();
        showModal(DialogParceiro, {
            list: parceiros,
            fullWidth: true,
            maxWidth: 'lg',
            onClose: clienteId => {
                if (clienteId) {
                    showModal(ImportDialog, {
                        title: 'Importação',
                        fields: [
                            { key: 'parceiro', label: 'ID Ordem Serviço', required: true, index: true },
                            { key: 'tipo', label: 'Tipo de tarefa', required: true },
                            { key: 'valencia', label: 'Valência', required: true },
                            { key: 'agendamento', label: 'Início Execução', required: false },
                            { key: 'tecnico', label: 'Técnico Atribuído', required: false },
                            { key: 'morada', label: 'Rua', required: true },
                            { key: 'cep', label: 'CEP', required: true },
                            { key: 'nome', label: 'Cliente', required: true },
                            { key: 'nif', label: 'NIF', required: true },
                            { key: 'telemovel', label: 'SMS', required: false },
                            { key: 'email', label: 'E-mail Cliente', required: false },
                            { key: 'dataCriacao', label: 'Data Criação Tarefa', required: true }
                        ],
                        importer: async (data) => {
                            return OblProcessoService.criaLinhaImport(data);
                        },
                        validator: async (row) => {
                            //Validação de NIF
                            row.data.nif = (String(row.data.nif).match(/\d+/g) || []).join('');
                            // Validação da data de agendamento
                            if (row.data.agendamento && !moment(row.data.agendamento, 'DD/MM/YYYY HH:mm', true).isValid()) {
                                row.valid = false;
                                row.error = 'Data de agendamento inválida';
                                return row;
                            }
                            if (row.data.agendamento && moment(row.data.agendamento, 'DD/MM/YYYY HH:mm', true).isBefore(moment(), 'day')) {
                                row.valid = false;
                                row.error = 'A data de agendamento não pode ser anterior à data atual';
                                return row;
                            }
                            if (row.data.agendamento) {
                                row.data.agendamento = moment(row.data.agendamento, 'DD/MM/YYYY HH:mm', true).format();
                            }
                            // Validação da data de criação da tarefa
                            if (!moment(row.data.dataCriacao, 'DD/MM/YYYY HH:mm', true).isValid()) {
                                row.valid = false;
                                row.error = 'Data de criação da tarefa inválida';
                                return row;
                            }
                            row.data.dataCriacao = moment(row.data.dataCriacao, 'DD/MM/YYYY HH:mm', true).format();
                            // Validação de cód. postal e lote
                            if (row.data.cep && !/^\d{4}-\d{3}$/.test(row.data.cep)) {
                                row.valid = false;
                                row.error = 'O código postal deve estar no formato 0000-000';
                                return row;
                            }
                            try {
                                const [cp4, cp3] = row.data.cep.split('-');
                                const cep = await OblProcessoService.getInfoCodigoPostal(cp4, cp3);
                                if (cep) {
                                    row.data.distrito = cep.distrito;
                                    row.data.concelho = cep.concelho;
                                    row.data.localidade = cep.result;
                                }
                                const lote = lotes.find(l => l.distrito.toUpperCase() === cep.distrito.toUpperCase());
                                // Update distrito error
                                if (!lote) {
                                    row.valid = false;
                                    row.error = `Não existe lote registado para ${cep.distrito}`;
                                    return row;
                                }
                                else {
                                    row.data.loteId = lote.id;
                                }
                            }
                            catch (e) {
                                row.valid = false;
                                row.error = `Código postal não registado: ${row.data.cep}`;
                                return row;
                            }
                            // Validação de valência
                            const valencia = valencias.find(v => v.codigo.toUpperCase() === row.data.valencia.toUpperCase());
                            if (!valencia) {
                                row.valid = false;
                                row.error = `Valência não registada: ${row.data.valencia}`;
                                return row;
                            }
                            else {
                                row.data.valenciaId = valencia.id;
                            }
                            // Validação do tipo de tarefa
                            const tarefa = tarefas.find(t => t.codigo.toUpperCase() === row.data.tipo.toUpperCase());
                            if (!tarefa) {
                                row.valid = false;
                                row.error = `Serviço não registado: ${row.data.tarefa}`;
                                return row;
                            }
                            else {
                                row.data.tipoId = tarefa.tipoId;
                            }
                            // Validação do técnico
                            const tecnico = tecnicos.find(t => t.email.localeCompare(row.data.tecnico, undefined, { sensitivity: 'accent' }) === 0);
                            if (!tecnico) {
                                row.valid = false;
                                row.error = `Técnico não registado: ${row.data.tecnico}`;
                                return row;
                            }
                            else if (tecnico) {
                                row.data.tecnicoId = tecnico.id;
                            }
                            // Limpa campos desnecessários
                            delete row.data.valencia;
                            delete row.data.tipo;
                            row.data.clienteId = clienteId;
                            console.log(JSON.parse(JSON.stringify(row.data)));
                            return row;
                        },
                        onClose: result => {
                            if (result) {
                            }
                            fetchData();
                        }
                    });
                }
            }
        });
    };
    const initialFetch = async () => {
        if (loading) {
            setLoading(false);
            const opt = await OblProcessoService.options();
            setOptions(opt);
            // Estado
            const auxEstados = await OblProcessoService.getEstados();
            setEstados(auxEstados);
            // Clientes
            const auxClientes = await OblProcessoService.getClientes();
            setClientes(auxClientes);
            // Valencia
            const auxValencias = await OblProcessoService.getValencias();
            setValencias(auxValencias);
            // Técnicos
            const auxTecnicos = await OblProcessoService.findTecnicos();
            setTecnicos(auxTecnicos);
        }
    };
    const excelGen = async (id, array) => {
        const wait = showModal(WaitDialog, { title: 'Por favor aguarde...' });
        let filename = `obler-processos-${id ? 'selecao' : 'exportacao'}-${moment().format('YYYY-MM-DD-HH-mm-ss')}.xlsx`;
        let filters = {};
        filter.forEach(r => {
            filters[r.id] = `${getType(r.type)}:${r.value}`;
        });
        if (id) {
            filters['id'] = `$in:${array.join(',')}`;
        }
        else {
            // Aplica filtro temporal
        }
        let sorter = [];
        sort.forEach(r => {
            sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
        });
        try {
            let o = await OblProcessoService.export({
                columns: columns.map(r => {
                    return {
                        accessorKey: r.exportKey ?? r.accessorKey,
                        header: r.header
                    };
                }),
                filter: filters,
                sortBy: sorter
            });
            if (o) {
                // Decode Base64 and convert to a Blob
                const binary = atob(o.$data);
                const bytes = new Uint8Array(binary.length);
                for (let i = 0; i < binary.length; i++) {
                    bytes[i] = binary.charCodeAt(i);
                }
                // Create a Blob and save it as an Excel file
                const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            }
        }
        catch (e) {
            if (e && e.data) {
                UIService.addToast(e.data.message);
            }
            else {
                UIService.addToast('Ocorreu um erro ao exportar dados!');
            }
        }
        wait.destroy();
    };
    const fetchData = async () => {
        try {
            let filters = {};
            filter.forEach(r => {
                filters[r.id] = `${getType(r.type)}:${r.value}`;
            });
            let sorter = [];
            sort.forEach(r => {
                sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
            });
            const aux = await OblProcessoService.table({
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                filter: filters,
                sortBy: sorter
            });
            $state.go($state.current.name, {
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                sortBy: sorter,
                filter: Object.keys(filter).length > 0 ? JSON.stringify(filters) : undefined
            }, {
                notify: false,
                reload: false,
                location: 'replace',
                inherit: true
            });
            // Update URL
            setData(aux);
        }
        catch (e) {
            console.log(e);
        }
        setRefetching(false);
    };
    useEffect(() => {
        initialFetch();
        if (!refetching) {
            setRefetching(true);
            fetchData();
        }
    }, [pagination, filter, sort]);
    const adminExport = () => {
        showModal(DialogDateRange, {
            title: 'Exportar informação',
            fullWidth: true,
            maxWidth: 'md',
            onClose: (r) => {
                if (!r?.startDate || !r?.endDate)
                    return; // Cancelled without setting anything
                let dialog = UIService.showWaiting();
                OblProcessoService.downloader(moment(r.startDate).format('YYYY-MM-DD'), moment(r.endDate).format('YYYY-MM-DD'))
                    .then(res => {
                    if (res.count > 0) {
                        let url = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + res.fileData;
                        let b = document.createElement('a');
                        b.href = url;
                        b.download = 'export.xlsx';
                        b.click();
                        dialog.close();
                        UIService.addToast(`Exportação efetuada com informação relativa a ${res.count} processos`);
                    }
                    else {
                        dialog.close();
                        UIService.addToast('Não existe informação relativa à semana escolhida');
                    }
                })
                    .catch(e => {
                    dialog.close();
                    UIService.addToast('Não foi possível exportar informação');
                });
            }
        });
    };
    return (<Box>
      <Box sx={{ mt: 2, mb: 2 }}>
        <Breadcrumbs aria-label='breadcrumb'>
          <Link underline='none' color='inherit'>
            Obler
          </Link>
          <Link underline='hover' color='text.primary' aria-current='page'>
            Processos
          </Link>
        </Breadcrumbs>
      </Box>

      <Box>
        <Table onDoubleClick={row => {
            window.open($state.href('app.obler.processos.details', { id: row.id }, { absolute: true }));
        }} storageKey={$state.current.name} data={data} columns={columns} initial={{
            sort: sort,
            filter: filter
        }} isLoading={refetching} options={options} onPaginate={setPagination} onFilter={setFilter} onSort={setSort} onExport={async () => {
            excelGen(false, []);
        }} selectActions={selected => {
            return [
                <Button onClick={async () => {
                        if (selected.length > 0) {
                            excelGen(true, selected);
                        }
                    }}>
                Exportar
              </Button>
            ];
        }} selectable={row => {
            return true;
        }}/>
      </Box>
      <Box sx={{
            position: 'fixed',
            margin: 2,
            bottom: 0,
            right: 0,
            display: 'flex',
            gap: 1
        }}>
        <Tooltip title={'Criar novo'}>
          <Fab size='small' color='default' onClick={async () => {
            $state.go('app.obler.processos.add');
        }}>
            <MdiIcon path={mdiPlus}/>
          </Fab>
        </Tooltip>
        <Tooltip title={'Exportar'}>
          <Fab size='small' color='primary' onClick={async () => {
            adminExport();
        }}>
            <MdiIcon path={mdiDownload}/>
          </Fab>
        </Tooltip>
        <Tooltip title={'Importação'}>
          <Fab size='small' color='error' onClick={async () => {
            importProcessos();
        }}>
            <MdiIcon path={mdiUpload}/>
          </Fab>
        </Tooltip>
      </Box>
    </Box>);
};
export default OblerProcessosListView;
